import type { ReactNode } from 'react';
import type { IconType } from 'react-icons';

interface EmptyStateProps {
  icon: IconType;
  title: string;
  children?: ReactNode;
  /** What to do about it — usually the button that fills the empty space. */
  action?: ReactNode;
}

/** An empty list that says why it is empty and what to do next. */
export default function EmptyState({ icon: Icon, title, children, action }: EmptyStateProps) {
  return (
    <div className="v-empty">
      <span className="v-empty__icon" aria-hidden="true">
        <Icon />
      </span>
      <p className="v-empty__title">{title}</p>
      {children && <p className="v-empty__text">{children}</p>}
      {action && <div className="v-empty__action">{action}</div>}
    </div>
  );
}
